import api from './api'
import { API_ENDPOINTS } from '../config/api'

// Buffer Time — owner-only. Har endpoint ke aage server par requireOwner laga
// hai, isliye staff/executive session me ye calls 403 lautati hain.
const bettingConfigService = {
  getSportsBuffers: async () => {
    const response = await api.get(API_ENDPOINTS.BETTING_CONFIG.BUFFER_SPORTS)
    return response.data
  },
  // { sport_id, league_key, market_key, buffer_seconds }
  // buffer_seconds 0 setting ko clear kar deta hai (platform default par wapas).
  // NOTE: purana `category: 'match_odds'` server ab reject karta hai —
  // 'match_odds' do markets me tut chuka hai (matchodds + match_other).
  saveSportsBuffer: async (payload) => {
    const response = await api.post(API_ENDPOINTS.BETTING_CONFIG.BUFFER_SPORTS, payload)
    return response.data
  },
  // { items: [{ sport_id, league_key, market_key, buffer_seconds }, …] } — UI ka
  // ek bucket (jaise Fancy) server ke kai market keys par jaata hai, isliye
  // saare ek hi call me.
  saveSportsBufferBulk: async (items) => {
    const response = await api.post(API_ENDPOINTS.BETTING_CONFIG.BUFFER_SPORTS_BULK, { items })
    return response.data
  },
  getCasinoBuffers: async () => {
    const response = await api.get(API_ENDPOINTS.BETTING_CONFIG.BUFFER_CASINO)
    return response.data
  },
  // { game_name, buffer_seconds }
  saveCasinoBuffer: async (payload) => {
    const response = await api.post(API_ENDPOINTS.BETTING_CONFIG.BUFFER_CASINO, payload)
    return response.data
  },
}

export default bettingConfigService
